(function () {
  function ensureBadges() {
    document.querySelectorAll(".cart-button").forEach((button) => {
      if (button.querySelector("[data-cart-count]")) return;
      const badge = document.createElement("span");
      badge.className = "cart-count";
      badge.dataset.cartCount = "";
      badge.hidden = true;
      button.appendChild(badge);
    });
  }

  function updateCartCount(count) {
    const number = Number(count) || 0;
    document.querySelectorAll("[data-cart-count]").forEach((badge) => {
      badge.textContent = String(number);
      badge.hidden = number < 1;
    });
    document.querySelectorAll(".cart-button").forEach((button) => {
      button.setAttribute("aria-label", number ? `View cart, ${number} item${number === 1 ? "" : "s"}` : "View cart");
      button.classList.toggle("has-items", number > 0);
    });
  }

  function showToast(message) {
    let toast = document.querySelector(".cart-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "cart-toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.dataset.visible = "true";
    window.clearTimeout(showToast.timer);
    showToast.timer = window.setTimeout(() => {
      toast.dataset.visible = "false";
    }, 2800);
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } }).then((response) => response.json());
  }

  function enhanceProductForm(form) {
    form.addEventListener("submit", (event) => {
      const submitter = event.submitter || form.querySelector('button[type="submit"]');
      if (!submitter || submitter.disabled) return;
      event.preventDefault();

      const originalText = submitter.textContent;
      submitter.disabled = true;
      submitter.textContent = "Adding";

      fetch("/cart/add.js", {
        method: "POST",
        headers: { Accept: "application/json" },
        body: new FormData(form)
      })
        .then((response) => {
          if (!response.ok) throw new Error("Cart add failed");
          return fetchCart();
        })
        .then((cart) => {
          updateCartCount(cart.item_count);
          submitter.textContent = "Added";
          showToast("Added to cart. Your cart is ready in the top right.");
          window.setTimeout(() => {
            submitter.textContent = originalText;
            submitter.disabled = false;
          }, 1600);
        })
        .catch(() => {
          submitter.textContent = "Try again";
          showToast("Could not add it. Please try again.");
          window.setTimeout(() => {
            submitter.textContent = originalText;
            submitter.disabled = false;
          }, 1800);
        });
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    ensureBadges();
    fetchCart().then((cart) => updateCartCount(cart.item_count)).catch(() => {});
    document.querySelectorAll('form[action="/cart/add"], form[action^="/cart/add"]').forEach(enhanceProductForm);
  });
})();
